import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

import axios from 'axios'
import VueAxios from 'vue-axios'
 
Vue.use(VueAxios, axios);

import VueRouter from 'vue-router'

// 1. Use plugin.
// This installs <router-view> and <router-link>,
// and injects $router and $route to all router-enabled child components
Vue.use(VueRouter)

import Warranties from './components/Waranties'
import Home from './components/Home'



const routes = [
    { path: '/items', component: Warranties },
    { path: '/', component: Home }
  ]
  
  // 3. Create the router instance and pass the `routes` option
  // You can pass in additional options here, but let's
  // keep it simple for now.
let router  = new VueRouter({
   mode:'history',
   routes // short for `routes: routes`
  });


  import moment from 'moment'

Vue.filter('formatDate', function(value) { 
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD')
  }
});

new Vue({
   router,
   vuetify,
 
  render: h => h(App)
}).$mount('#app')  
